export default __webpack_public_path__ + "static/media/t.13bf4f0d.svg";